import { createApp } from 'vue'
import App from './App.vue'
import { Button } from 'vant';
import { Search } from 'vant';
import { Dialog } from 'vant';
import { Sticky } from 'vant';
import { Icon } from 'vant';
import { Field, CellGroup } from 'vant';
import { Switch } from 'vant';
import { showToast } from 'vant';
import axios from 'axios';
import 'vant/lib/index.css';
// 新增 flexible 导入
import 'amfe-flexible'

const app = createApp(App);
app.config.errorHandler = (err, vm, info) => {
    console.error('未捕获的错误:', err);
};
app.use(axios);
app.use(Icon);
app.use(Sticky);
app.use(Search);
app.use(Button);
app.use(Dialog);
app.use(Field);
app.use(CellGroup);
app.use(Switch);
app.mount('#app')
